<template>
    <el-menu-item
        v-if="!menu.children || !menu.children.length"
        :index="resolvePath(menu.path, basePath)"
    >
        <SvgIcon :name="menu.menuIcon" />
        <template #title>{{ menu.title }}</template>
    </el-menu-item>
    <el-submenu
        :index="resolvePath(menu.path)"
        v-else
    >
        <template #title>
            <SvgIcon :name="menu.menuIcon" />
            <span>{{ menu.title }}</span>
        </template>
        <side-menu
            v-for="child in menu.children"
            :key="child.path"
            :menu="child"
            :base-path="menu.path"
        ></side-menu>
    </el-submenu>
</template>

<script>
import variable from '@/assets/css/variable.module.scss';

export default {
    name: 'SideMenu',
    props: {
        menu: {
            type: Object,
            required: true
        },
        basePath: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            onlyOneChild: {},
            variable,
        }
    },
    computed: {
        userStore() {
            return useUserStore();
        },
    },
    methods: {
        hasOneShowingChild(children = [], parent) {
            if (children.length === 1) {
                this.onlyOneChild = children[0];
                return true
            }
            if (children.length === 0) {
                this.onlyOneChild = { ...parent };
                return true
            }
            return false
        },
        resolvePath(routePath, parentPath) {
            const getFullPath = path => {
                if (!path) return '';
                const hasBasePath = path.split('')[0] === '/';
                return hasBasePath ? path : `/${path}`;
            };
            if (routePath.includes('/')) {
                // 全路径
                return getFullPath(routePath);
            }
            // 子路径
            return getFullPath(parentPath) + getFullPath(routePath);
        },
    },
}
</script>

<style lang="scss" scoped>
.el-tooltip__trigger .SvgIcon {
    margin: 0;
}
.SvgIcon {
    margin-right: 16px;
}
</style>
